export default __webpack_public_path__ + "static/media/kl-04.f07cb78d.png";